<template>
  <div class="login">
    <PaperGraph class="paper-wave"/>
    <div class="login-box">
      <div class="title">您好，欢迎使用智能批改助手！</div>
      <div class="flex login-input">
        <input class="flex-1"
          id="username"
          type="text"
          placeholder="请输入账号"
          v-model="username">
        <div class="login-border"></div>
      </div>
      <div class="flex login-input a-center">
        <input class="flex-1"
          :type="type"
          id="password"
          placeholder="密码"
          v-model="password">
        <div class="login-border"></div>
        <svg-icon v-if="isOpen" name="eye-open"
          @click.native="toggleEye()"
          class="flex a-center m-l-5 c-p"></svg-icon>
        <svg-icon v-else name="eye-closed"
          @click.native="toggleEye()"
          class="flex a-center m-l-5 c-p"></svg-icon>
      </div>
      <div class="login-submit" @click="loginHandler()">登录</div>
    </div>

    <div class="login-footer">
      <span class="m-r-20">©2020合心科技出品</span>
      <span>京ICP备14033449号</span>
    </div>
  </div>
</template>

<script>
// import { login, getOwn } from '@apis/account'
import Vue from 'vue'
import { getErrorMessage } from '../../scripts/guard'
import Account from '../../scripts/account'
import PaperGraph from '/src/components/PaperGraph'
export default {
  components: { PaperGraph },
  name: 'LoginIndex',
  data () {
    return {
      username: '',
      password: '',
      isOpen: false,
      type: 'password'
    }
  },
  methods: {
    toggleEye () {
      this.isOpen = !this.isOpen
      this.type = this.isOpen ? 'text' : 'password'
    },
    loginHandler (form) {
      this.$guard()(async () => {
        let user = await Account.login({
          username: this.username,
          password: this.password
        })
        if (!Account.check(user)) {
          this.$message('您输入的用户名或密码错误')
          return
        }
        Vue.prototype.$user = user
        this.$router.push('/')
        this.$message.success('登入成功')
      }, e => {
        if (e.code === 2) {
          this.$message('您输入的用户名或密码错误')
        } else {
          let error = getErrorMessage(e)
          this.$message(error || '输入错误')
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .login {
    // background: url(./images/login-bg.jpg);
    height: 100%;
    $w: 90%;
    $h: 320px;
    $green: #12C4BE;

    .title {
      font-size: 28px;
      text-align: center;
      margin-bottom: 50px;
    }

    &-box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: $w;
      // height: $h;
      max-width: 400px;
      padding: 30px 0;
      border-radius: 10px;
      transform: translate(-50%, -50%);
    }
    $borderH: 3px;
    &-input {
      position: relative;
      height: 48px;
      margin-bottom: 20px;
      font-size: 20px;
      color: #595F6E;
      line-height: 48px;
      overflow: hidden;
      // border-bottom: $borderH solid #000;

      &:last-child {
        margin-bottom: 0;
      }
      .label {
        margin-right: 10px;
      }

      input {
        display: block;
        font-size: 20px;
        border: none;
        outline: none;
        background: none;
      }

      input:focus + .login-border {
        &:after {
          width: 100%;
          height: $borderH;
          background: $green
        }
      }

      input:focus {
        color: $green
      }

      .login-border {
        position: absolute;
        bottom: 0;
        width: 100%;

        &:before,
        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          height: 1px;
          transition: width .5s;
          background: #9a9595;
        }
        &:before {
          width: 100%;
        }
        &:after {
          width: 0%;
        }
      }
    }
    &-submit {
      width: 100%;
      height: 50px;
      margin-top: 50px;
      font-size: 14px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      background: $green;
    }
  }
  .paper-wave {
    width: 100%;
    height: 300px;
    max-height: 200px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    pointer-events: none;
    opacity: 0.9;
  }

  .login-footer {
    width: 100%;
    line-height: 40px;
    text-align: center;
    position: fixed;
    bottom: 10px;
    left: 0;
    right: 0;
    pointer-events: none;
    color: gray;
  }
</style>
